const Vue = require('vue')

Vue.component('ui-dropdown2', require('components/ui/Dropdown2.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/dropdown2.js